import React from 'react';

function AppMain({ children }) {
    return (
        <div className="app-main">
            {children}
        </div>
    );
}

export default AppMain;
